import * as React from "react"

import { cn } from "@/lib/utils"

type DivProps = React.ComponentProps<"div">

function ListPageHeader({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="list-page-header"
      className={cn(
        "flex flex-col gap-3 border-b px-4 pt-4 pb-3 md:flex-row md:items-start md:justify-between md:gap-4 md:px-8 md:pt-6 md:pb-4",
        className,
      )}
      {...props}
    />
  )
}

function ListPageHeaderContent({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="list-page-header-content"
      className={cn("min-w-0 flex-1", className)}
      {...props}
    />
  )
}

function ListPageHeaderTitle({
  className,
  ...props
}: React.ComponentProps<"h2">) {
  return (
    <h2
      data-slot="list-page-header-title"
      className={cn("text-lg font-semibold md:text-xl md:font-bold", className)}
      {...props}
    />
  )
}

function ListPageHeaderDescription({
  className,
  ...props
}: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="list-page-header-description"
      className={cn("mt-0.5 text-sm text-muted-foreground md:mt-1", className)}
      {...props}
    />
  )
}

function ListPageHeaderActions({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="list-page-header-actions"
      className={cn("flex flex-wrap items-center gap-2 md:shrink-0", className)}
      {...props}
    />
  )
}

function ListPageToolbar({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="list-page-toolbar"
      className={cn(
        "flex flex-wrap items-center gap-2 border-b bg-background px-4 py-3 md:gap-3 md:px-8 md:py-4",
        className,
      )}
      {...props}
    />
  )
}

function ListPageFilterField({
  label,
  htmlFor,
  className,
  children,
}: {
  label: string
  htmlFor?: string
  className?: string
  children: React.ReactNode
}) {
  return (
    <div
      data-slot="list-page-filter-field"
      className={cn("flex flex-col gap-1", className)}
    >
      <label
        htmlFor={htmlFor}
        className="text-xs font-medium text-muted-foreground"
      >
        {label}
      </label>
      {children}
    </div>
  )
}

function ListPageFooter({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="list-page-footer"
      className={cn(
        "flex flex-wrap items-center justify-between gap-3 border-t px-4 py-3 md:gap-4 md:px-8 md:py-4",
        className,
      )}
      {...props}
    />
  )
}

export {
  ListPageHeader,
  ListPageHeaderContent,
  ListPageHeaderTitle,
  ListPageHeaderDescription,
  ListPageHeaderActions,
  ListPageToolbar,
  ListPageFilterField,
  ListPageFooter,
}
